export default __webpack_public_path__ + "53a700f769ca8b4e7b474c2057e9b065.png";